module.exports = __webpack_public_path__ + "static/media/good_bye_2016.e724a9e2.png";